import { gql } from '@apollo/client'
import { Matter } from 'share/domain/case'

// DEACTIVATE CASE

export const DEACTIVATE_CASE = gql`
  mutation DEACTIVATE_CASE($id: Int!, $reason: String!) {
    cases {
      deactivate(id: $id, reason: $reason) {
        id
        caseNumber
        accountId
        active
        attorneyName
        caseType
        lastVisitedDate
        openDate
        firm {
          id
          name
          officeId
          emailAddress
          iconUrl
          street
          city
          state
          zip
          phone
          fax
          website
        }
      }
    }
  }
`

export interface DeactivateCaseVariables {
  id: number
  reason: string
}

export interface MutationCaseResponse {
  cases: {
    activate: Matter
  }
}

// REACTIVATE CASE

export const REACTIVATE_CASE = gql`
  mutation REACTIVATE_CASE($id: Int!) {
    cases {
      activate(id: $id) {
        id
        accountId
        active
        attorneyName
        caseType
        lastVisitedDate
        openDate
        firm {
          id
          name
          officeId
          emailAddress
          iconUrl
          street
          city
          state
          zip
        }
      }
    }
  }
`

export interface ReactivateCaseVariables {
  id: number
}

// start of update last visited date

export const UPDATE_CASE_LAST_VISIT = gql`
  mutation UPDATE_CASE_LAST_VISIT($case: CaseUpdateDtoInput!) {
    cases {
      update(case: $case) {
        id
        lastVisitedDate
      }
    }
  }
`
export interface UpdateCaseLastVisitVariables {
  case: {
    id: number
    lastVisitedDate: string
  }
}

export interface UpdateCaseLastVisitResponse {
  cases: {
    update: {
      id: number
      lastVisitedDate: string
    }
  }
}

// end of update last visited date

export const UPDATE_QUESTIONNAIRE_SHOWN_INSTRUCTIONS_FLAG = gql`
  mutation UPDATE_QUESTIONNAIRE_SHOWN_INSTRUCTIONS_FLAG(
    $request: UpdateQuestionnaireShownInstructionsFlagRequestDtoInput!
  ) {
    cases {
      updateQuestionnaireShownInstructionsFlag(request: $request) {
        success
      }
    }
  }
`

export interface UpdateQuestionnaireShownInstructionsFlagVariables {
  request: {
    caseId: number
    flag: boolean
  }
}

export interface UpdateQuestionnaireShownInstructionsFlagResponse {
  cases: {
    updateQuestionnaireShownInstructionsFlag: {
      success: boolean
    }
  }
}

export const UPDATE_QUESTIONNAIRE_SHOWN_TERMSANDCONDITIONS_FLAG = gql`
  mutation UPDATE_QUESTIONNAIRE_SHOWN_TERMSANDCONDITIONS_FLAG(
    $request: UpdateQuestionnaireShownTermsAndConditionsFlagRequestDtoInput!
  ) {
    cases {
      updateQuestionnaireShownTermsAndConditionsFlag(request: $request) {
        success
      }
    }
  }
`

export interface UpdateQuestionnaireShownTermsAndConditionsFlagVariables {
  request: {
    caseId: number
    flag: boolean
  }
}

export interface UpdateQuestionnaireShownTermsAndConditionsFlagResponse {
  cases: {
    updateQuestionnaireShownTermsAndConditionsFlag: {
      success: boolean
    }
  }
}

export const START_RESUME_QUESTIONNAIRE_SECTION = gql`
  mutation START_RESUME_QUESTIONNAIRE_SECTION(
    $request: StartResumeQuestionnaireSectionRequestDtoInput!
  ) {
    cases {
      startResumeQuestionnaireSection(request: $request) {
        success
      }
    }
  }
`

export interface StartResumeQuestionnaireSectionVariables {
  request: {
    caseId: number
    sectionId: number
  }
}

export interface StartResumeQuestionnaireSectionResponse {
  cases: {
    startResumeQuestionnaireSection: {
      success: boolean
    }
  }
}

export const COMPLETE_QUESTIONNAIRE_SECTION = gql`
  mutation COMPLETE_QUESTIONNAIRE_SECTION(
    $request: CompleteQuestionnaireSectionRequestDtoInput!
  ) {
    cases {
      completeQuestionnaireSection(request: $request) {
        success
      }
    }
  }
`

export interface CompleteQuestionnaireSectionVariables {
  request: {
    caseId: number
    sectionId: number
  }
}

export interface CompleteQuestionnaireSectionResponse {
  cases: {
    completeQuestionnaireSection: {
      success: boolean
    }
  }
}

export const SAVE_QUESTIONNAIRE_SECTION_DATA = gql`
  mutation SAVE_QUESTIONNAIRE_SECTION_DATA(
    $request: SaveQuestionnaireSectionDataRequestDtoInput!
  ) {
    cases {
      saveQuestionnaireSectionData(request: $request) {
        success
      }
    }
  }
`

export interface SaveQuestionnaireSectionDataVariables {
  request: {
    caseId: number
    sectionId: number
    questionKey: string
    data: string | null
    questionCompleteFlag: boolean
  }
}

export interface SaveQuestionnaireSectionDataResponse {
  cases: {
    saveQuestionnaireSectionData: {
      success: boolean
    }
  }
}

export const SAVE_QUESTIONNAIRE_SECTION_CURRENT_ACTIVE_QUESTION = gql`
  mutation SAVE_QUESTIONNAIRE_SECTION_CURRENT_ACTIVE_QUESTION(
    $request: SaveQuestionnaireSectionCurrentActiveQuestionRequestDtoInput!
  ) {
    cases {
      saveQuestionnaireSectionCurrentActiveQuestion(request: $request) {
        success
      }
    }
  }
`

export interface SaveQuestionnaireSectionCurrentActiveQuestionVariables {
  request: {
    caseId: number
    sectionId: number
    currentActiveQuestionId: number
  }
}

export interface SaveQuestionnaireSectionCurrentActiveQuestionResponse {
  cases: {
    saveQuestionnaireSectionCurrentActiveQuestion: {
      success: boolean
    }
  }
}

export const SUBMIT_QUESTIONNAIRE = gql`
  mutation SUBMIT_QUESTIONNAIRE($request: SubmitQuestionnaireRequestDtoInput!) {
    cases {
      submitQuestionnaire(request: $request) {
        success
      }
    }
  }
`

export interface SubmitQuestionnaireVariables {
  request: {
    caseId: number
  }
}

export interface SubmitQuestionnaireResponse {
  cases: {
    submitQuestionnaire: {
      success: boolean
    }
  }
}

export const UPDATE_IS_COMPLETE_ALL_CHECKLIST_UPLOADED_DOCUMENTS_FLAG = gql`
  mutation UPDATE_IS_COMPLETE_ALL_CHECKLIST_UPLOADED_DOCUMENTS_FLAG(
    $request: UpdateIsCompleteAllChecklistUploadedDocumentsRequestDtoInput!
  ) {
    cases {
      updateIsCompleteAllChecklistUploadedDocumentsFlag(request: $request) {
        success
      }
    }
  }
`

export interface UpdateCompleteAllChecklistDocsVariables {
  request: {
    caseId: number
    isCompleteAllChecklistUploadedDocuments: boolean
  }
}

export interface UpdateCompleteAllChecklistDocsResponse {
  cases: {
    updateIsCompleteAllChecklistUploadedDocumentsFlag: {
      success: boolean
    }
  }
}
